import { ArkActionTypes } from '../../../../../actions/dashboards/Ark'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'

export type NoInteractionsSkuPayload = {
    sku: string
}[]

interface NoInteractionsSkuState {
    values: number[]
    labels: string[]
    total: number
    perc: null
}

/**
 * Ark No Interactions Sku reducer
 */
const arkNoInteractionsSku = buildAsyncStatReducer<NoInteractionsSkuPayload, NoInteractionsSkuState>({
    key: Metrics.ARK_NO_INTERACTIONS_SKU,
    types: ArkActionTypes.DASHBOARD_ARK_NO_INTERACTIONS_SKU,
    transform: (state, { payload }) => {
        const skusList: string[] = (payload || []).map(({ sku }) => sku)
        const sortedList = skusList.sort()

        return {
            values: sortedList.map(() => 0),
            labels: sortedList,
            total: skusList.length,
            perc: null,
        }
    },
})

export default arkNoInteractionsSku
